export default __webpack_public_path__ + "static/media/illustration-recruit-6-w@2x.f5cc9773.webp";